import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  PatternValidator,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnValidatorCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ModalidadeService } from "src/app/shared/services/modalidade.service";
import { EmpresasBloqueadasService } from "./empresas-bloqueadas.service";

@Component({
    selector: "app-empresas-bloqueadas-individual",
    templateUrl: "./empresas-bloqueadas-individual.component.html",
    standalone: false
})
export class EmpresasBloqueadasIndividualComponent
  implements OnInit, OnDestroy
{
  private readonly destroy$ = new Subject<any>();
  empresaForm: FormGroup;
  textoTermoAceite: string = "";
  checkCiencia: boolean = false;
  @ViewChild("mensagemTermoAceite") mensagemTermoAceite: TemplateRef<any>;
  @ViewChild("botoesTermosAceite") botoesTermosAceite: TemplateRef<any>;

  constructor(
    private router: Router,
    formBuilder: FormBuilder,
    private modalService: BnModalMessageService,
    private modalidadeService: ModalidadeService,
    private bnLoadingService: BnLoadingService,
    private bnAlertsService: BnAlertsService,
    private empresasBloqueadasService: EmpresasBloqueadasService
  ) {
    this.empresaForm = formBuilder.group({
      cnpj: [null, [Validators.required]],
    });
  }
  ngOnInit(): void {
    this.modalidadeService.modalidade$
      .pipe(takeUntil(this.destroy$))
      .subscribe((modalidadeSigla) => {
        const modalidade = this.modalidadeService
          .getModalidades()
          .find((m) => m.sigla === modalidadeSigla);
        this.textoTermoAceite = modalidade.textoTermoEmpresasBloqueadas;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  irParaTelaPesquisa() {
    this.router.navigate(["/empresas-bloqueadas"]);
  }

  abrirModalConfirmar() {
    const { cnpj } = this.empresaForm.value;

    if (!cnpj || !/^[a-zA-Z0-9]{8}$/.test(cnpj)) {
      this.bnAlertsService.alertaErro("Erro", "CNPJ inválido.");
      return;
    }

    this.modalService.abrir(
      "Termos e condições",
      null,
      "md",
      this.mensagemTermoAceite,
      this.botoesTermosAceite
    );
  }

  cancelarAceite() {
    this.checkCiencia = false;
    this.modalService.dismiss("abortou a consulta de empresas bloqueadas");
  }

  async confirmarAceite() {
    this.checkCiencia = false;
    this.modalService.dismiss();
    try {
      this.bnLoadingService.bloqueiaTela();
      const { cnpj } = this.empresaForm.value;
      await this.empresasBloqueadasService.consultaIndividual(cnpj).toPromise();
      this.bnLoadingService.liberaTela();
      this.irParaTelaPesquisa();
      this.bnAlertsService.alertaSucesso(
        "Sucesso",
        'A pesquisa CNPJ foi enviada.\nO arquivo com a resposta pode ser verificado no menu "Envio/consulta de arquivos"'
      );
    } catch (err) {
      console.log(err);
      this.bnLoadingService.liberaTela();
      this.bnAlertsService.alertaErro(
        "Erro",
        "Houve um erro no processamento do protocolo."
      );
    }
  }
}
